import React from 'react';


const CertificateSeniorityView = ({logoImg, signatureImg, title, firstText, secondText, representative, workPosition, business, date}) => {
    return ( 
        <>
            <pre><img src={logoImg}  alt=""/></pre>
            <h3 className="text-center">{title}</h3>     
            <br></br>
            <br></br>
            <p>{firstText}</p>                
            <br></br>
            <p>{secondText}</p>      
            <br></br>
            <br></br>
            <br></br>
            
            <pre className="text-center">
                <p><img src={signatureImg} alt="" className="signatue-certificate"/></p>
                <p>{representative}</p>
                <p>{workPosition}</p>
                <p>{business}</p>
            </pre>
            <p>{date}</p>
        </>
     );
}
 
export default CertificateSeniorityView;